import { useState } from 'react';
import { HTTP_RESPONSE_CODES } from '../../common/helpers/constants';
import commonResource from '../../locales/th/common.json';

export function useCommentAlertMessage() {
  const [statusCode, setStatusCode] = useState<number>(null);
  const showAlertMessage = (statusCode: number) => {
    setStatusCode(statusCode);
    setTimeout(() => {
      setStatusCode(null);
    }, 5000);
  };

  const codeMessageResource: Record<string, string> =
    commonResource.comment.codeMessage;
  return {
    alertMessage:
      statusCode && statusCode !== HTTP_RESPONSE_CODES.OK
        ? (codeMessageResource[statusCode] ??
          codeMessageResource[HTTP_RESPONSE_CODES.BadRequest])
        : '',
    showAlertMessage,
  };
}
